import { useEffect, useState } from 'react'
import { Button, Grid, MenuItem, Select, TextField } from '@mui/material'
import { useDispatch } from 'react-redux'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { SEARCH_RETURN_ORDERS } from '../../store/types'
import {
    ReturnOrderStatusList,
    returnOrderTypeList,
} from '../../constants/orderType'

const SearchReturnOrder = ({
    displayKeyword,
    searchStatus,
    displayFromDate,
    displayToDate,
}) => {
    const dispatch = useDispatch()
    const [keyword, setKeyword] = useState('')
    const [status, setStatus] = useState('null')
    const [searchFromDate, setSearchFromDate] = useState('')
    const [searchToDate, setSearchToDate] = useState('')

    useEffect(() => {
        setKeyword(displayKeyword ?? '')
        setStatus(searchStatus ?? 'null')
        setSearchFromDate(displayFromDate ?? '')
        setSearchToDate(displayToDate ?? '')
    }, [displayKeyword, searchStatus, displayFromDate, displayToDate])
    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch({
            type: SEARCH_RETURN_ORDERS,
            payload: {
                keyword,
                status,
                searchFromDate,
                searchToDate,
            },
        })
    }
    return (
        <div className="search-container">
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
                <Grid container justify="center" alignItems="center" gap={2}>
                    <Grid item xs={3}>
                        <TextField
                            // variant="outlined"
                            fullWidth
                            id="keyword"
                            label="Search..."
                            size="small"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                components={['DatePicker', 'DatePicker']}
                            >
                                <DatePicker
                                    label="From date"
                                    value={searchFromDate}
                                    onChange={(newValue) =>
                                        setSearchFromDate(newValue)
                                    }
                                />
                                <DatePicker
                                    label="To date"
                                    value={searchToDate}
                                    onChange={(newValue) =>
                                        setSearchToDate(newValue)
                                    }
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={2}>
                        <Select
                            labelId={`select-label-status`}
                            fullWidth
                            name="status"
                            id="status"
                            size="small"
                            value={status}
                            // variant="standard"
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <MenuItem value="null">--All--</MenuItem>
                            {Object.values(ReturnOrderStatusList)?.map(
                                (option) => (
                                    <MenuItem key={option} value={option}>
                                        {returnOrderTypeList[option]}
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </Grid>
                    <Grid item style={{ marginLeft: '10px' }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            type="submit"
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

export default SearchReturnOrder
